/* Blog Product Card - Standalone JS for article pages */
(function() {
  /* Image carousel swipe (mobile) */
  if (window.innerWidth <= 768) {
    document.querySelectorAll('[data-blog-card-carousel]').forEach(function(carousel) {
      var track = carousel.querySelector('[data-blog-image-track]');
      var dots = carousel.querySelectorAll('[data-blog-dot]');
      if (!track) return;

      var currentIndex = 0;
      var startX = 0;
      var currentTranslate = 0;
      var prevTranslate = 0;
      var isDragging = false;
      var hasDragged = false;
      var imageItems = track.querySelectorAll('.blog-product-card__image-item');
      var totalImages = imageItems.length;
      if (totalImages <= 1) return;

      function updateCarousel(index, animate) {
        currentIndex = Math.max(0, Math.min(index, totalImages - 1));
        var translateX = -(currentIndex * 100);
        if (animate !== false) {
          track.classList.remove('is-dragging');
        } else {
          track.classList.add('is-dragging');
        }
        track.style.transform = 'translateX(' + translateX + '%)';
        currentTranslate = translateX;
        prevTranslate = translateX;
        dots.forEach(function(dot, i) {
          dot.classList.toggle('active', i === currentIndex);
        });
      }

      function getX(e) {
        return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
      }

      function onStart(e) {
        startX = getX(e);
        isDragging = true;
        hasDragged = false;
        track.classList.add('is-dragging');
      }

      function onMove(e) {
        if (!isDragging) return;
        var diff = getX(e) - startX;
        var pct = (diff / track.offsetWidth) * 100;
        currentTranslate = prevTranslate + pct;
        track.style.transform = 'translateX(' + currentTranslate + '%)';
        if (Math.abs(diff) > 5) {
          hasDragged = true;
          if (e.cancelable) e.preventDefault();
        }
      }

      function onEnd(e) {
        if (!isDragging) return;
        isDragging = false;
        var moved = currentTranslate - prevTranslate;
        if (Math.abs(moved) > 20) {
          if (moved > 0 && currentIndex > 0) updateCarousel(currentIndex - 1);
          else if (moved < 0 && currentIndex < totalImages - 1) updateCarousel(currentIndex + 1);
          else updateCarousel(currentIndex);
        } else {
          updateCarousel(currentIndex);
        }
        if (hasDragged) e.preventDefault();
      }

      track.addEventListener('touchstart', onStart, { passive: false });
      track.addEventListener('touchmove', onMove, { passive: false });
      track.addEventListener('touchend', onEnd, { passive: false });
      updateCarousel(0);
    });
  }

  /* Add to cart */
  document.querySelectorAll('[data-blog-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Toevoegen...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Failed');
        btn.classList.add('added');
        btn.textContent = 'Toegevoegd!';
        return fetch('/cart.js');
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function() {
          btn.textContent = originalText;
          btn.classList.remove('added');
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });
  });
})();
